import axios, { AxiosError } from 'axios'

import { maxBodyLenth, maxConstLength } from '@/common/const'
import { isTokenExists, getToken } from '@/helper/localStorageAccessor'
import router from '@/router'
import store from '@/store'

const baseURL = process.env.VUE_APP_API_BASE_URL || 'http://localhost:4000/api'

export const apiServer = axios.create({
  baseURL,
  responseType: 'json',
  headers: { 'Content-Type': 'application/json' },
  maxBodyLength: maxBodyLenth,
  maxContentLength: maxConstLength,
})
apiServer.interceptors.response.use((response) => response, errorInterceptor)

export const apiServerFormData = axios.create({
  baseURL,
  responseType: 'json',
  headers: { 'Content-Type': 'multipart/form-data' },
  maxBodyLength: maxBodyLenth,
  maxContentLength: maxConstLength,
})
apiServerFormData.interceptors.response.use((response) => response, errorInterceptor)

export function setAuthHeader(value: string): void {
  apiServer.defaults.headers.common['Authorization'] = value
  apiServerFormData.defaults.headers.common['Authorization'] = value
}

if (isTokenExists()) {
  setAuthHeader(`Bearer ${getToken()}`)
}

// ローカル or 開発環境ならtrue
export function isDev(): boolean {
  return process.env.NODE_ENV === 'local' || process.env.NODE_ENV === 'development'
}

function errorInterceptor(error: AxiosError) {
  // 認証エラーのときは、強制的にログイン画面に移動
  if (error?.response?.status === 403) logout()

  return Promise.reject(error)
}

function logout() {
  // vueコンポーネント外ではuseXXX系のコンポジションは使用できないので
  // 直接storeやrouterを使用する
  store.dispatch('logout')
  router.push({ name: 'lineLogin' })
}
